import { render } from "./Unauthorized.vue?vue&type=template&id=b156b4d2"
import script from "./Unauthorized.vue?vue&type=script&lang=js"
export * from "./Unauthorized.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__